import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_FoodMeal_Api = async (params) => {
    const { data } = await request.post(
        `/FoodMeal/GetAll`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_FoodMeal_Api = async (id) => {
    const { data } = await request.delete(
        `/FoodMeal/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_FoodMeal_Api = async (params) => {
    const { data } = await request.post(
        `/FoodMeal/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_FoodMeal_Api = async (id) => {
    const { data } = await request.get(
        `/FoodMeal/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_FoodMeal_Api = async (params) => {
    const { data } = await request.post(
        `/FoodMeal/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetFoodsOfSectionDay_FoodMeal_Api = async (params) => {
    const { data } = await request.post(
        `/FoodMeal/GetFoodsOfSectionDay`,
        params
    );
    return data;
};
